module.exports = {"id":"6acbfba6-2659-44da-beef-68c9719d3d2b","name":"buyer-awards","items":[{"name":"name","type":"text-field","props":{"required":true,"label":"Award Name","width":12},"id":"276dd208-310c-4f3d-adf7-acbb513c7e10"},{"type":"inline","items":[{"type":"text-field","name":"year","props":{"label":"Year Received","format":"number","width":4},"id":"f237b7ad-01c9-4569-826a-690cdfe64717"}],"id":"7ab9596d-fffb-4abc-899c-7cc53d0ff44a"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/buyer/data_table_forms/awards.json
// module id = h4dy
// module chunks = 0